//TODO: replace with enum from BE
export enum EFilterType {
  TEXT = 'text',
  DATE = 'date',
  NUMBER = 'number',
  SELECT = 'select',
}
